<template>
    <CInputGroupText>
        {{ value }}
    </CInputGroupText>
</template>

<script setup>
import { CInputGroupText } from '@coreui/vue-pro'

defineProps({
    value: {
        type: String,
        default: null
    }
})

</script>
